import React from 'react'
import { observer } from 'mobx-react-lite'
import clsx from 'clsx'

import { Box, FormLabel, Grid } from '@material-ui/core'

import { useBoolState } from '../hooks/commonHooks'
import { useMessages } from '../hooks/snackbarHooks'
import { useApi, useStore } from '../hooks/storeHook'
import { useSettingsPageStyles } from '../hooks/settingsPageStylesHook'

export const MoySkladAttribuesPanel =
  observer(
    () => {
      const {showSuccess, showError} = useMessages()

      const {syncStore} = useStore()

      const api = useApi()
      const [isLoading, setIsLoading, setNotLoading] = useBoolState()
      const classes = useSettingsPageStyles()

      const onVerifyOrderAttributes = async () => {
        setIsLoading()

        try {
          await api.userSync.verifyMoySkladOrderAttributes()
          showSuccess('Доп. поля проверены успешно!')
        } catch (e) {
          console.error('Failed to verify MoySklad order attributes', e)
          showError('Не удалось проверить')
        } finally {
          setNotLoading()
        }
      }

      if (!syncStore.moySkladAccount) {
        return null
      }

      return (
        <Box className={classes.pageContainer}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Grid container className={clsx(classes.settingsTopic, 'default-border')}>
                <Grid item className={classes.root} xs={12}>
                  <Box width={'100%'} display="flex" justifyContent="space-between" alignItems="center">
                    <Box>
                      <FormLabel className={classes.boldLabel}>
                        Дополнительные поля заказа
                      </FormLabel>
                    </Box>
                    <button
                      disabled={isLoading}
                      className={clsx(classes.saveButton, 'default-button')}
                      style={{margin: 0}}
                      onClick={onVerifyOrderAttributes}>
                      <p>
                        {
                          isLoading ? 'Проверяем...' : 'Проверить доп. поля'
                        }
                      </p>
                    </button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      )
    })